import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
const { color, typography } = primitives;

export const ActionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 526px;
`;

export const ActionItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ActionItem = styled.div`
  display: flex;
  gap: 12px;
`;

export const ActionIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${color.green7};
  color: ${color.white};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ActionContent = styled.div`
  flex: 1;
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const ActionTitle = styled.h4`
  font-family: ${typography.family0};
  color: ${color.black};
  font-size: ${typography.size3};
  font-weight: ${typography.weight3};
  margin: 0;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    font-size: ${typography.size2};
    line-height: ${typography.lineHeight3};
  }
`;

export const ActionLink = styled.button`
  background: none;
  border: none;
  color: ${color.electricBlue7};
  font-family: ${typography.family0};
  font-size: ${typography.size3};
  font-weight: ${typography.weight3};
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  text-align: left;
  @media (max-width: 768px) {
    font-size: ${typography.size2};
    line-height: ${typography.lineHeight3};
  }

  &:hover {
    color: ${color.electricBlue8};
  }
`;

export const OrderValue = styled.span`
  font-family: ${typography.family0};
  color: ${color.electricBlue7};
  font-size: ${typography.size3};
  font-weight: ${typography.weight3};
  display: flex;
  align-items: center;
  text-decoration: underline;
  @media (max-width: 768px) {
    font-size: ${typography.size2};
    line-height: ${typography.lineHeight3};
  }
`;

export const EmailNotification = styled.div`
  font-family: ${typography.family0};
  color: ${color.black};
  font-size: ${typography.size4};
  line-height: ${typography.lineHeight4};
  font-weight: ${typography.weight4};
  @media (max-width: 768px) {
    font-size: ${typography.size2};
    line-height: ${typography.lineHeight3};
    font-weight: ${typography.weight3};
  }
`;
